import React from "react";
import { CircularProgress, DialogContentText, Stack, Typography } from "@mui/material";
import ModalLayout from "./Layout";
import ModalLayoutHeader from "./Layout/Header";
import ModalLayoutContent from "./Layout/Content";
import ModalLayoutFooter from "./Layout/Footer";
import ModalLayoutBtn from "./Layout/Btn";
import ModalLayoutInput from "./Layout/Input";
import { Check, LogIn, Save } from "react-feather";
import { createFivetranConnectorService } from "../../services/taps.js";

/**
 *
 * @param {{
 *  isShown: boolean;
 *  onHide: () => void;
 *  changeTapAlias: (e: React.ChangeEvent) => void;
 *  savedAlias: boolean;
 *  tapAlias: string;
 *  newSchema: string;
 *  fivetranName: string;
 *  setNewSchema: () => void;
 *  schemaSaved: boolean;
 *  schema: string;
 *  embeddedUrl: string;
 *  schemaOverwritten: string;
 *  onConnectorCreated: (url: string) => void;
 * }} data
 */
const FivetranAuthModal = ({
  isShown,
  onHide,
  changeTapAlias,
  savedAlias,
  tapAlias,
  newSchema,
  fivetranName,
  setNewSchema,
  schemaSaved,
  schema,
  embeddedUrl,
  schemaOverwritten,
  onConnectorCreated,
}) => {
  const [isSaving, setIsSaving] = React.useState(false);
  return (
    <ModalLayout isShown={isShown} onHide={onHide}>
      <ModalLayoutHeader onHide={onHide}>
        Authenticate with Fivetran
        <img
          src="https://assets-global.website-files.com/6130fa1501794ed4d11867ba/613e9ef6d25b70060cb305ca_fivetran-logo.fb5c1b9c.svg"
          width="12%"
          style={{
            position: "absolute",
            right: "48px",
          }}
          alt=""
        />
      </ModalLayoutHeader>
      <ModalLayoutContent>
        <DialogContentText
          component={"h5"}
          textAlign={"center"}
          color="#6c757d"
        >
          We partner with Fivetran for our data ingestion layer.
        </DialogContentText>
        <DialogContentText
          textAlign={"center"}
          color="#6c757d"
        >
          Once your data tap is created, upon clicking the Authenticate button
          below, you will be redirected to Fivetran to authenticate, then back
          to Datajolt and your data tap will be ready for use.
        </DialogContentText>

        <Typography
          display={"block"}
          mt={3}
          mb={2}
          fontWeight={"bold"}
        >
          Name your tap to identify it easily in Datajolt
        </Typography>
        <ModalLayoutInput
          type="text"
          onChange={changeTapAlias}
          placeholder="Your tap alias"
          disabled={savedAlias}
          aria-describedby="basic-addon2"
          style={{
            margin: 0,
          }}
        />

        <Typography
          display={"block"}
          mt={3}
          mb={2}
          fontWeight={"bold"}
        >
          Specify the schema name for your data
        </Typography>
        <ModalLayoutInput
          type="text"
          onChange={setNewSchema}
          placeholder="Enter schema name (e.g., datajolt_shopify)"
          disabled={schemaSaved}
          aria-describedby="basic-addon2"
          style={{
            margin: 0,
          }}
        />
      </ModalLayoutContent>
      <ModalLayoutFooter>
        <ModalLayoutBtn
          color="primary"
          disabled={!tapAlias || !schema || savedAlias || schemaSaved || isSaving}
          onClick={async () => {
            setIsSaving(true);
            try {
              const response = await createFivetranConnectorService({
                tap_alias: tapAlias,
                service: "fivetran",
                schema: schema,
                connector_name: fivetranName
              });
              if (response?.data) {
                onConnectorCreated(response.data);
              }
            } finally {
              setIsSaving(false);
            }
          }}
          style={{ marginRight: "12px", height: "38px" }}
        >
          {isSaving ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <>
              {!(savedAlias || schemaSaved) && <Save size={16} style={{ marginRight: "8px" }} />}
              Save{(savedAlias || schemaSaved) ? "d" : ""}
              {(savedAlias || schemaSaved) && <Check size={16} style={{ marginLeft: "8px" }} />}
            </>
          )}
        </ModalLayoutBtn>
        <ModalLayoutBtn
          href={embeddedUrl}
          target="_blank"
          rel="noopener noreferrer"
          color="success"
          disabled={!embeddedUrl}
          style={{
            color: "white !important",
            height: "38px",
            "&:hover": {
              color: "white !important"
            }
          }}
          sx={{
            color: "white !important",
            height: "38px",
            "&:hover": {
              color: "white !important"
            }
          }}
        >
          {schemaOverwritten ? (
            <CircularProgress size={16} color="#fff" />
          ) : (
            <>
              <LogIn size={16} /> Authenticate
            </>
          )}
        </ModalLayoutBtn>
        <Typography color="#6c757d">
          This will open in a new window
        </Typography>
      </ModalLayoutFooter>
    </ModalLayout>
  );
};

export default FivetranAuthModal;
